//---------------------------------------
//     Submenu display on enter
//---------------------------------------

const JsSubNavDropdown = {
  init () {

    /*
    * Sub menu hover - options
    */

    if ( $('.customNavSubmenu').length ) {

      $('.customNavSubmenu').click(function() {
        $('.dropdown-content').toggleClass("show");
      });

      // function navFunction() {
      //   document.getElementById("navDropdown").classList.toggle("show");
      // }

      // var dropmenu = document.getElementsByClassName('dropdown-content');


      // window.onclick = function(event) {
      //   if (!event.target.matches('.dropbtn')) {

      //     var dropdowns = document.getElementsByClassName("dropdown-content");
      //     var i;
      //     for (i = 0; i < dropdowns.length; i++) {

      //       var openDropdown = dropdowns[i];
      //       if (openDropdown.classList.contains('show')) {
      //         openDropdown.classList.remove('show');

      //       }
      //     }
      //   } 
      // }
    }

  }
};

export default JsSubNavDropdown;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/submenu.js